/* eslint-disable no-return-await */
import { getDomain } from './getParams';
import { configExist, generateId } from './';
import { saveTextProperties } from './../../redux/actions/entities/texts';
import { generateText } from '../../helpers/babyBookHelper';

export const DEFAULT_FONT = 'Allura';
export const DEFAULT_STANDARD_FONT = 'Montserrat';
export const DEFAULT_FONT_SIZE = 60;
export const DEFAULT_TEXT_COLOR = '#7f7f7f';

export const TEXT_PROPERTIES = {
  text: '',
  font: DEFAULT_FONT,
  fontSize: DEFAULT_FONT_SIZE,
  color: '#000',
  isActive: true,
  isOverflow: false,
  isMoveable: true,
  isEditable: true,
  images: {
    thumbnail: {
      image: '',
      relativeURl: '',
      width: 0,
      height: 0,
    },
    full: {
      image: '',
      relativeURl: '',
      width: 0,
      height: 0,
    },

  },
};

async function postTextProperties(data) {
  const referer = getDomain();
  const imageUrl = configExist('labelsURL', referer);

  const response = await fetch(imageUrl, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: new Headers({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    }),
  });
  const responsejson = await response.json();
  return responsejson;
}

export async function postTextData(data, dispatch) {
  return await postTextProperties(data).then(async (response) => {
    if (response === undefined || response.error) {
      throw new Error('Service not running');
    }
    const {
      thumbnail,
      imageSize,
    } = response.status;

    const { absolute } = thumbnail;
    const thumbnailImage = absolute;
    const properties = {
      text: data.text,
      images: {
        thumbnail: {
          image: thumbnailImage,
          relativeURl: thumbnail.relative,
          width: imageSize.thumbnail.width,
          height: imageSize.thumbnail.height,
        },
        full: {
          image: '',
          relativeURl: '',
          width: 0,
          height: 0,
        },

      },
    };

    await dispatch(saveTextProperties(data.id, properties));

    return true;
  });
}

export function getTextWrapper(marginSizes, EditorLimit, BeforeMarginLimit) {
  const wrapperLimits = [];

  const TextWraper = {
    width: (EditorLimit.width - (marginSizes.left + marginSizes.right)) - BeforeMarginLimit,
    height: ((EditorLimit.height - (marginSizes.top + marginSizes.bottom)) - BeforeMarginLimit),
  };
  wrapperLimits.push(TextWraper);


  return wrapperLimits;
}

export async function generateWeddingTexts(store, text, pageId, setParentStyle = {}, fontIndex = null, textIndex = null) {
  const index = generateId(Object.keys(store.getState().entities.texts), 10000);
  const lastIndex = index;
  const textColor = '#7c7472';

  const hasParentStyle = Object.entries(setParentStyle).length !== 0 ? setParentStyle[text.type] : {};

  const properties = {
    bookId: store.getState().bookProperties.productID,
    id: lastIndex,
    font: 'font' in hasParentStyle ? hasParentStyle.font : (text.font || DEFAULT_FONT),
    fontSize: 'fontSize' in hasParentStyle ? hasParentStyle.fontSize[textIndex][fontIndex] : (text.fontSize || 45),
    color: 'color' in hasParentStyle ? hasParentStyle.color : (text.color || textColor),
    text: text.text,
    isEditable: true,
    isDefault: true,
    type: 'type' in text ? text.type : 'Standard',
    positions: {
      x: text.positions ? text.positions.x : 0,
      y: text.positions ? text.positions.y : 0,
    },
  };

  const textProperties = Object.assign(properties);

  const generated = await generateText(textProperties, pageId, lastIndex, store.dispatch);
  return generated;
}



// WEBPACK FOOTER //
// ./src/redux/helpers/texts.js